import React from "react";
import { Col, Row } from "reactstrap";

const Pagination = ({ totalItems, pageSize, currentPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / pageSize) || 0;

  if (totalPages <= 0) {
    return null;
  }

  const handlePrev = (e) => {
    e.preventDefault();
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

  const handlePage = (e, page) => {
    e.preventDefault();
    if (page >= 1 && page <= totalPages) onPageChange(page);
  };

  // Build page numbers to show: 1 ... 4 5 6 ... N when many pages
  const getPageNumbers = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    const pages = [];
    pages.push(1);
    if (currentPage > 3) pages.push("ellipsis-left");
    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);
    for (let p = start; p <= end; p++) {
      if (!pages.includes(p)) pages.push(p);
    }
    if (currentPage < totalPages - 2) pages.push("ellipsis-right");
    if (totalPages > 1) pages.push(totalPages);
    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <React.Fragment>
      <Row>
        <Col lg={12} className="mt-4 pt-2">
          <nav aria-label="Navegación de páginas de ofertas">
            <ul className="pagination job-pagination mb-0 justify-content-center">
              <li className={`page-item ${currentPage <= 1 ? "disabled" : ""}`}>
                <button
                  type="button"
                  className="page-link"
                  onClick={handlePrev}
                  tabIndex={currentPage <= 1 ? -1 : 0}
                  aria-label="Página anterior"
                >
                  <i className="mdi mdi-chevron-double-left fs-15" aria-hidden></i>
                </button>
              </li>
              {pageNumbers.map((item, idx) =>
                item === "ellipsis-left" || item === "ellipsis-right" ? (
                  <li key={`ellipsis-${idx}`} className="page-item disabled">
                    <span className="page-link" aria-hidden>…</span>
                  </li>
                ) : (
                  <li
                    key={item}
                    className={`page-item ${currentPage === item ? "active" : ""}`}
                  >
                    <button
                      type="button"
                      className="page-link"
                      onClick={(e) => handlePage(e, item)}
                      aria-label={`Página ${item}`}
                      aria-current={currentPage === item ? "page" : undefined}
                    >
                      {item}
                    </button>
                  </li>
                )
              )}
              <li className={`page-item ${currentPage >= totalPages ? "disabled" : ""}`}>
                <button
                  type="button"
                  className="page-link"
                  onClick={handleNext}
                  tabIndex={currentPage >= totalPages ? -1 : 0}
                  aria-label="Página siguiente"
                >
                  <i className="mdi mdi-chevron-double-right fs-15" aria-hidden></i>
                </button>
              </li>
            </ul>
          </nav>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Pagination;
